import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from 'api/base';
import { recordingObjectionKeys } from 'hooks/useRecordingObjectionStatus';
import type { RecordingObjectionScope, RecordingObjectionStatus } from 'types/recordingObjection';
import { trackError } from 'utils/trackError';

export function useRecordObjection(medatixxPatientId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation<RecordingObjectionStatus, Error, RecordingObjectionScope>({
    mutationFn: (scope) =>
      post('recordingObjection', { medatixxPatientId, scope }) as Promise<RecordingObjectionStatus>,
    onSuccess: (status) => {
      queryClient.setQueryData(recordingObjectionKeys.status(medatixxPatientId), status);
    },
    onError: (error) => {
      trackError(error, { context: 'recordObjection' });
    },
  });
}
